export const getDeviceOS = (): "ios" | "android" | "desktop" => {
  const ua = navigator.userAgent || (window as any).opera;

  if (/android/i.test(ua)) {
    return "android";
  }

  if (/iPad|iPhone|iPod/.test(ua)) {
    return "ios";
  }

  return "desktop";
};

export const getIsInAppBrowser = () => {
  return navigator.userAgent.match(/inapp|NAVER|KAKAOTALK|Snapchat|Line|WirtschaftsWoche|Thunderbird|Instagram|everytimeApp|WhatsApp|Electron|wadiz|AliApp|zumapp|iPhone(.*)Whale|Android(.*)Whale|kakaostory|band|twitter|DaumApps|DaumDevice\/mobile|FB_IAB|FB4A|FBAN|FBIOS|FBSS\/[^1]/i) ? true : false;
};